module.exports = __webpack_public_path__ + "static/media/filter.032fcb18.svg";